import BorderCard from '@/components/borderCard'
import Carousel from '@/components/carousel'
import DesktopSourcingRegionlist from '@/components/farmerSolution/DesktopSourcingRegionlist'
import MobileSourcingRegionList from '@/components/farmerSolution/MobileSourcingRegionList'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import OurBrand from '@/components/ourBrand'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import {
  ASSET_DIR,
  BENEFITS,
  CERTIFICATE_LIST,
  FACILITIES,
  SPICES_SOURCING_REGION,
  STRINGS,
} from '@/constants/agriOutput'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const AgriOutput = () => (
  <LayoutWithNavigation>
    <section className="m-auto my-4 px-6 max-w-7xl">
      <PageHeader
        heading={STRINGS.PAGE_HEADING}
        subHeading={STRINGS.PAGE_SUBHEADING}
      />
      <p className="mb-2.5 pt-4 pb-[30px] font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
        {STRINGS.DESCRIPTION}
      </p>
      <OurBrand />

      <section className="mt-7 md:mt-[60px]">
        <h2 className="mb-2.5 font-natosans-medium md:text-[45px] text-3xl leading-[1.1]">
          {STRINGS.TITLE}
        </h2>
        <h4 className="mt-4 font-natosans-medium text-black text-xl md:text-3xl leading-[1.4]">
          {STRINGS.SUBTITLE}
        </h4>
        <section className="flex">
          <article className="md:w-1/2">
            <p className="mb-2.5 pt-4 font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
              {STRINGS.ABOUT_DEHAAT_DETAILED.split(/<@>(.+?)<\/@>/g).map(
                (text, index) =>
                  index % 2 == 0 ? (
                    text
                  ) : (
                    <span className="font-natosans-medium" key={text}>
                      {text}
                    </span>
                  )
              )}
            </p>
            <ul className="ml-4 px-4 text-neutral-80 leading-relaxed list-disc">
              {STRINGS.MAJOR_SPICES.map((spice, index) => (
                <li key={index}>{spice}</li>
              ))}
            </ul>
            <h4 className="mt-4 font-natosans-medium text-black text-xl">
              {STRINGS.OTHER_SPICES_TITLE}
            </h4>
            <p className="mb-2.5 pt-1 font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
              {STRINGS.OTHER_SPICES_DESCRIPTION}
            </p>
            <ul className="ml-4 px-4 text-neutral-80 leading-relaxed list-disc">
              {STRINGS.OTHER_SPICES.map((spice, index) => (
                <li key={index}>{spice}</li>
              ))}
            </ul>
          </article>
          <article className="hidden relative md:flex items-center md:w-1/2">
            <Picture
              image={`${ASSET_DIR}/spices`}
              imageAlt="Rack full of fresh vegetables and fruits"
              imageStyle="h-full"
              pictureStyle="absolute flex justify-center items-center w-full h-full"
            />
          </article>
        </section>
      </section>

      <section className="mt-7 md:mt-[60px]">
        <h2 className="md:mb-[17px] font-natosans-semibold font-semibold text-[#101010] text-[28px] md:text-3xl leading-[1.1875]">
          {STRINGS.SOURCING_REGIONS}
        </h2>
        <DesktopSourcingRegionlist accorditonList={SPICES_SOURCING_REGION} />
        <MobileSourcingRegionList accorditonList={SPICES_SOURCING_REGION} />
      </section>

      <section className="mt-7 md:mt-[60px]">
        <h2 className="mt-4 font-natosans-medium text-black text-3xl">
          {STRINGS.BACKWARD_INTEGRATION_PROGRAMME}
        </h2>
        <section className="flex">
          <article className="pr-4 md:w-1/2">
            <p className="mb-2.5 pt-4 font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
              {STRINGS.ABOUT_BACKWARD_INTEGRATION_PROGRAMME.split(
                /<@>(.*?)<\/@>/g
              ).map((text, index) =>
                index % 2 === 0 ? (
                  text
                ) : (
                  <span
                    className="font-natosans-medium text-footer-grey"
                    key={index}
                  >
                    {text}
                  </span>
                )
              )}
            </p>
            <ul className="ml-4 px-4 text-neutral-80 leading-relaxed list-disc">
              {STRINGS.BACKWARD_INTEGRATION_BENEFITS.map((spice, index) => (
                <li key={index}>{spice}</li>
              ))}
            </ul>
            <p className="mb-2.5 pt-4 font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
              {STRINGS.BACKWARD_INTEGRATION_PROGRAMME_PROGRESS.split(
                /<@>(.*?)<\/@>/g
              ).map((text, index) =>
                index % 2 === 0 ? (
                  text
                ) : (
                  <span
                    className="font-natosans-medium text-footer-grey"
                    key={index}
                  >
                    {text}
                  </span>
                )
              )}
            </p>
            <article className="md:hidden relative flex items-center">
              <Picture
                image={`${ASSET_DIR}/backward-integration`}
                imageAlt="Rack full of fresh vegetables and fruits"
                imageStyle="h-full w-full"
                pictureStyle="flex justify-center items-center w-full h-full py-2"
              />
            </article>
            <h4 className="mb-2.5 pt-4 font-natosans-medium text-xl whitespace-pre-wrap">
              {STRINGS.BACKWARD_INTEGRATION_PROGRAMME_AREAS}
            </h4>
            <ul className="ml-4 px-4 font-natosans-light text-footer-grey leading-relaxed list-disc">
              <li>
                <span className="font-natosans-medium text-neutral-80">
                  Chilli
                </span>{' '}
                – Andhra Pradesh, Telangana, Karnataka
              </li>
              <li>
                <span className="font-natosans-medium text-neutral-80">
                  Turmeric
                </span>{' '}
                – Andhra Pradesh, Maharashtra, Odisha
              </li>
              <li>
                <span className="font-natosans-medium text-neutral-80">
                  Cumin{' '}
                </span>
                – Barmer, Jaisalmer (Rajasthan)
              </li>
              <li>
                <span className="font-natosans-medium text-neutral-80">
                  Coriander
                </span>{' '}
                – Kota, Ramganj Mandi (Rajasthan)
              </li>
              <li>
                <span className="font-natosans-medium text-neutral-80">
                  Fennel
                </span>{' '}
                – Nagaur (Rajasthan)
              </li>
            </ul>
          </article>
          <article className="hidden relative md:flex items-center md:w-1/2">
            <Picture
              image={`${ASSET_DIR}/backward-integration`}
              imageAlt="Rack full of fresh vegetables and fruits"
              imageStyle="h-full w-full"
              pictureStyle="absolute flex justify-center items-center w-full h-full ml-4 py-6"
            />
          </article>
        </section>
      </section>

      <section className="mt-7 md:mt-[60px]">
        <h2 className="mt-4 font-natosans-medium text-black text-3xl">
          {STRINGS.SOWING_HARVESTING_CALENDAR}
        </h2>
        <section className="flex flex-col items-center">
          <article className="w-full">
            <p className="mb-2.5 pt-4 font-natosans-light text-footer-grey text-base text-start whitespace-pre-wrap">
              {STRINGS.ABOUT_SOWING_HARVESTING.split(/<@>(.*?)<\/@>/g).map(
                (text, index) =>
                  index % 2 === 0 ? (
                    text
                  ) : (
                    <span
                      className="font-natosans-medium text-footer-grey"
                      key={index}
                    >
                      {text}
                    </span>
                  )
              )}
            </p>
            <div className="flex flex-col gap-[-4px]">
              {STRINGS.HARVEST_CALENDAR_IMAGE.map((image, index) => (
                <div
                  key={index}
                  className={`flex ${
                    index % 2 !== 0 ? 'justify-end' : 'justify-start'
                  }`}
                >
                  <Picture
                    image={`${ASSET_DIR}/${image}`}
                    imageAlt="Harvest calender of spices"
                    imageStyle="h-full transform hover:scale-105 transition-transform duration-300 ease-in-out object-contain aspect-3/2 max-md:580px"
                    pictureStyle="relative flex justify-center items-center w-fit h-48 md:h-80 px-3"
                  />
                </div>
              ))}
            </div>
          </article>
        </section>
      </section>

      <section className="mt-7 md:mt-[60px]">
        <h2 className="mt-4 font-natosans-medium text-black text-3xl">
          {STRINGS.OUR_CERTIFICATIONS}
        </h2>
        <Carousel
          imageList={CERTIFICATE_LIST}
          aspectRatio={377 / 233}
          desktopImageCount={4}
          mobileImageCount={1}
        />
        <p className="mb-4 font-natosans-light text-footer-grey text-base whitespace-pre-wrap">
          {STRINGS.ABOUT_CERTIFICATION.split(/<@>(.*?)<\/@>/g).map(
            (text, index) =>
              index % 2 === 0 ? (
                text
              ) : (
                <span
                  className="font-natosans-medium text-footer-grey"
                  key={index}
                >
                  {text}
                </span>
              )
          )}
        </p>
      </section>

      {/* <h2 className="my-2.5 font-natosans-light font-natosans-medium text-black text-3xl">
        {STRINGS.BENEFITS}
      </h2>
      <section className="flex md:flex-row flex-col my-[30px]">
        {BENEFITS.map(({ image, label }) => (
          <BorderCard
            image={image}
            label={label}
            key={label}
            imageStyle="w-[76px] aspect-square"
          />
        ))}
      </section>
      <h2 className="my-2.5 font-natosans-medium text-black text-3xl">
        {STRINGS.FACILITIES_AVAILABLE}
      </h2>
      <section className="flex md:flex-row flex-col flex-wrap mt-[30px]">
        <div className="hidden md:inline-flex relative md:w-1/5">
          <article className="bg-[#6bb51e] pt-[45px] pr-[32.5px] pb-[25px] pl-[35px] font-natosans-medium text-white text-base md:text-left text-center">
            {STRINGS.IN_HOUSE}
          </article>
          <aside className="top-1/2 right-0 absolute bg-[#6bb51e] h-12 aspect-square rotate-45 -translate-y-1/2 translate-x-1/2" />
        </div>
        {FACILITIES.map(({ image, label }) => (
          <BorderCard
            image={image}
            label={label}
            key={label}
            imageStyle="w-[78px] aspect-square"
          />
        ))}
      </section> */}
    </section>
  </LayoutWithNavigation>
)

export default AgriOutput
